<template>
  <div class="carga-archivos">
    <div>
      <Titulo titulo="Carga de archivos" />
    </div>
    <b-row class="justify-content-center align-items-center">
      <b-col cols="12" md="10">
        <b-tabs v-model="tabActivo" content-class="mt-3" @activate-tab="cambiarTab">
          <b-tab title="Cargar anexos" active>
            <div class="mt-3 text-right">
              <img v-if="loading" class="loading" src="@/assets/images/loader.gif" alt />
            </div>
            <br />
            <div class="mx-auto" v-if="!loading">
              <div class="text-justify">
                <h4 class="color-secundary mb-4" v-text="'Anexos de reclamación'"></h4>
                <hr />
              </div>
              <form @submit.prevent id="cargue" style="padding-right: 70px" v-if="!loading">
                <b-form-file ref="archivo" size="md" placeholder="Selecione un archivo" browse-text="Anexar"
                  drop-placeholder="Suelte los archivos aqui...." :disabled="dataLength == 0 || loading" class="mt-2"
                  :accept="tipo_archivo ? tipo_archivo : '.pdf'" :multiple="multiple ? multiple : false"
                  @input="prevalidar">
                  <template slot="file-name" slot-scope="{ names }">
                    <b-badge v-if="names.length > 0" variant="dark" class="ml-1">{{ names[0] }} | {{ names.length }}
                      Archivo(s)
                      seleccionado(s)</b-badge>
                  </template>
                </b-form-file>

                <b-alert show dismissible fade variant="primary" v-if="uploadResponse" class="mt-4"
                  @dismissed="showDismissibleAlertSuccess = false">
                  <div class="text-center titulo-alerta-succes">¡Alerta!</div>
                  {{ uploadResponse.mensaje }}
                  <ul>
                    <li v-for="(
value, prerequisito, index
                  ) in uploadResponse.prerequisitos" :key="index">
                      {{ prerequisito }}
                      <ul>
                        <li v-for="(_value, cargue, _index) in value" :key="_index">
                          {{ _value }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </b-alert>

                <b-alert show dismissible fade variant="danger" v-if="uploadRespnseError" class="mt-4"
                  @dismissed="showDismissibleAlertError = false">
                  <div class="text-center titulo-alerta-danger">¡Alerta!</div>
                  <ul>
                    <li v-for="(value, error, index) in uploadRespnseError" :key="index">
                      {{ error }}
                      <ul>
                        <li v-for="(_value, archivo, _index) in value" :key="_index">
                          {{ _value[0] }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </b-alert>

              </form>

              <b-row class="mt-3" style="padding: 70px">
                <b-col cols="6" class="pr-1">
                  <b-button type="button" block :disabled="dataLength == 0 || loading || resumen.porEnviar == 0"
                    class="button-carga" @click="enviarArchivos">
                    <i class="fa fa-upload mr-1" aria-hidden="true"></i>
                    Enviar {{ resumen.porEnviar }} archivo(s) válido(s)
                  </b-button>
                </b-col>
                <b-col cols="6" class="pl-1">
                  <b-button type="button" block :disabled="dataLength == 0 || descargandoPendientes"
                    class="button-carga" @click="descargarPendientes">
                    <i :class="descargandoPendientes ? 'fa fa-spinner fa-spin mr-1' : 'fa fa-download mr-1'"
                      aria-hidden="true"></i>
                    {{ descargandoPendientes ? "Descargando..." : "Descargar pendientes" }}
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <div class="mx-auto" v-if="sending.length">
              <b-alert show variant="success" v-if="loteEnCola" class="mb-3">
                <i class="fa fa-check-circle mr-1" aria-hidden="true"></i>
                <strong>El lote {{ loteEnCola }} quedó en cola.</strong>
                Ya puedes cerrar esta ventana o seguir trabajando: el procesamiento continúa en el servidor
                y el resultado quedará en
                <a href="#" @click.prevent="tabActivo = 1">Historial de cargues</a>.
              </b-alert>

              <b-alert show variant="info" v-if="envio_anexos" class="mb-3">
                <div class="mb-2">
                  <i class="fa fa-spinner fa-spin mr-1" aria-hidden="true"></i>
                  <strong>Subiendo {{ subida.terminados }} de {{ subida.archivos }} archivo(s)</strong>
                  · {{ progresoSubida.mbEnviados }} MB de {{ progresoSubida.mbTotal }} MB
                  <span v-if="progresoSubida.restante"> · faltan {{ progresoSubida.restante }}</span>
                </div>
                <b-progress :value="progresoSubida.porcentaje" :max="100" show-progress animated></b-progress>
                <small class="d-block mt-2">
                  No cierres esta pestaña hasta que termine la subida. Después el lote queda en cola y podrás salir.
                </small>
              </b-alert>

              <b-alert show :variant="envio_anexos ? 'info' : 'primary'" class="mb-3">
                <template v-if="batchId">
                  <strong>Lote:</strong> {{ batchId }}
                  <span class="mx-2">|</span>
                </template>
                <span><strong>Por enviar:</strong> {{ resumen.porEnviar }}</span>
                <span class="mx-2">|</span>
                <span class="text-success"><strong>Enviados:</strong> {{ resumen.buenos }}</span>
                <span class="mx-2">|</span>
                <span class="text-danger"><strong>Rechazados:</strong> {{ resumen.malos }}</span>
                <template v-if="procesando">
                  <span class="mx-2">|</span>
                  <span><i class="fa fa-spinner fa-spin mr-1"></i>Procesando lote...</span>
                </template>
              </b-alert>
              <b-row>
                <b-col col sm="12" md="6" lg="4" class="pb-4">
                  <b-form-select v-model="sendingType" :options="sendingTypeOpt"></b-form-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="my-1" col sm="12" md="6" lg="4" v-for="(file, index) in sending_pagina"
                  v-bind:key="inicioPagina + index">
                  <b-card no-body>
                    <b-card-body>
                      <b-row>
                        <b-col cols="2" class="p-0" style="font-size: 1.2rem">
                          <i class="fa fa-file-pdf-o mr-2" aria-hidden="true"></i>
                        </b-col>
                        <b-col class="text-truncate p-0" v-b-tooltip.hover :title="file.name">
                          {{ file.name }}
                        </b-col>
                        <b-col cols="2" class="p-0">
                          <b-badge variant="danger" pill v-b-toggle="'collapse' + (inicioPagina + index)" href="#"
                            class="ml-2 float-right" v-if="file.error" v-b-tooltip.hover
                            title="Clic para ver la causa del rechazo">
                            <i class="fa fa-exclamation-circle mr-1" aria-hidden="true"></i>
                            <span>{{ file.errors.length }}</span>
                          </b-badge>
                          <b-badge variant="success" pill href="#" v-if="file.success" v-b-tooltip.hover
                            title="Enviado">
                            <i class="fa fa-check-circle"></i>
                          </b-badge>
                          <b-badge variant="info" pill v-if="!file.error && !file.success" v-b-tooltip.hover
                            title="Válido, listo para enviar">
                            <i class="fa fa-clock-o"></i>
                          </b-badge>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col style="font-size: 0.9rem">
                          <b-collapse :id="'collapse' + (inicioPagina + index)" v-if="file.errors.length">
                            <b-row v-for="(error, i) in file.errors" v-bind:key="i">
                              <b-col>
                                <em>{{ error }}</em>
                              </b-col>
                            </b-row>
                          </b-collapse>
                        </b-col>
                      </b-row>
                      <div>
                        <b-progress height="1px" :value="file.progress" :max="100"
                          :variant="file.error ? 'danger' : file.success ? 'success' : ''"></b-progress>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
              <b-pagination v-if="sending_filtered.length > archivosPorPagina" v-model="paginaArchivos"
                :total-rows="sending_filtered.length" :per-page="archivosPorPagina" align="center"
                class="mt-3"></b-pagination>
            </div>
          </b-tab>

          <b-tab title="Historial de cargues">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h4 class="color-secundary mb-0" v-text=""></h4>
              <b-button size="sm" class="button-carga" :disabled="cargandoBatches" @click="getBatches">
                <i :class="cargandoBatches ? 'fa fa-spinner fa-spin mr-1' : 'fa fa-refresh mr-1'"
                  aria-hidden="true"></i>
                Actualizar
              </b-button>
            </div>
            <b-table :items="batches" :fields="batchFields" :busy="cargandoBatches" small striped responsive show-empty
              empty-text="No tiene cargues en lote registrados.">
              <template #table-busy>
                <div class="text-center my-2">
                  <i class="fa fa-spinner fa-spin mr-1"></i> Cargando...
                </div>
              </template>
              <template #cell(batch)="data">
                <span class="text-nowrap">{{ data.item.batch }}</span>
              </template>
              <template #cell(estado)="data">
                <b-badge :variant="varianteEstado(data.item.estado)">{{ data.item.estado }}</b-badge>
              </template>
              <template #cell(acciones)="data">
                <b-button size="sm" variant="outline-primary"
                  :disabled="!data.item.log_disponible || descargandoLog == data.item.batch" v-b-tooltip.hover.left
                  :title="data.item.log_disponible ? 'Descargar log' : 'El log estará disponible al finalizar el procesamiento'"
                  @click="descargarLog(data.item)">
                  <i :class="descargandoLog == data.item.batch ? 'fa fa-spinner fa-spin' : 'fa fa-download'"
                    aria-hidden="true"></i>
                </b-button>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "AnexoReclamacion",
  data: () => {
    return {
      pagination: false,
      files: new FormData(),
      uploadResponse: null,
      uploadRespnseError: null,
      showDismissibleAlertSuccess: false,
      showDismissibleAlertError: false,
      recomendacion:
        "En este espacio podrás cargar la documentación requerida para la reclamación",
      tipo_archivo: "",
      multiple: true,
      perPage: 10000,
      dataPendientes: [],
      dataLength: 0,
      // Cada item: { name, file, progress, errors, success, error }
      // file = objeto File original (solo para los que pasaron la prevalidación)
      sending: [],
      sendingType: null,
      sendingTypeOpt: [
        { value: null, text: "Filtrar archivos por", disabled: true },
        { value: "todos", text: "Todos" },
        { value: "por_enviar", text: "Por enviar" },
        { value: "buenos", text: "Enviados" },
        { value: "erroneos", text: "Erróneos" },
      ],
      end_consulta_anexos: false,
      envio_anexos: false,
      procesando: false,
      descargandoPendientes: false,
      batchId: null, // identificador único del lote de cargue actual
      archivosPorBloque: 15, // archivos enviados por petición
      bloquesSimultaneos: 3, // peticiones en paralelo
      bytesPorBloque: 50 * 1024 * 1024, // tamaño máximo por petición (debe ser <= post_max_size)
      tabActivo: 0,
      paginaArchivos: 1,
      archivosPorPagina: 48, // tarjetas por página (múltiplo de 3 por la grilla)
      loteEnCola: null, // lote que ya quedó encolado tras la subida
      // Progreso global de la subida (una sola barra en lugar de una por archivo)
      subida: { archivos: 0, terminados: 0, bytesTotal: 0, bytesEnviados: 0, inicio: 0, ahora: 0 },
      batches: [],
      cargandoBatches: false,
      descargandoLog: null,
      batchFields: [
        { key: "fecha_cargue", label: "Fecha de cargue", class: "text-center align-middle" },
        { key: "batch", label: "Lote", class: "text-center align-middle" },
        { key: "estado", label: "Estado", class: "text-center" },
        { key: "total_archivos", label: "Archivos", class: "text-center" },
        { key: "registros_procesados", label: "Procesados", class: "text-center" },
        { key: "registros_buenos", label: "Exitosos", class: "text-center" },
        { key: "registros_malos", label: "Rechazados", class: "text-center" },
        { key: "acciones", label: "Log", class: "text-center" },
      ],
    };
  },
  computed: {
    loading() {
      return this.end_consulta_anexos == true && this.envio_anexos == false
        ? false
        : true;
    },
    resumen() {
      let buenos = 0;
      let malos = 0;
      let porEnviar = 0;
      for (const s of this.sending) {
        if (s.success) buenos++;
        else if (s.error) malos++;
        else porEnviar++;
      }
      return { buenos, malos, porEnviar };
    },
    sending_filtered: function () {
      switch (this.sendingType) {
        case "erroneos":
          return this.sending.filter((sent) => sent.error);
        case "buenos":
          return this.sending.filter((sent) => sent.success);
        case "por_enviar":
          return this.sending.filter((sent) => !sent.error && !sent.success);
        case "todos":
        default:
          return this.sending;
      }
    },
    inicioPagina() {
      return (this.paginaArchivos - 1) * this.archivosPorPagina;
    },
    sending_pagina() {
      return this.sending_filtered.slice(this.inicioPagina, this.inicioPagina + this.archivosPorPagina);
    },
    clavesPendientes() {
      const claves = new Set();
      for (const dato of this.dataPendientes || []) {
        if (dato.pagare) {
          claves.add(String(dato.pagare));
          claves.add(String(dato.pagare).replace("NG_", ""));
        }
        if (dato.cedula) claves.add(String(dato.cedula));
      }
      return claves;
    },
    progresoSubida() {
      const { bytesTotal, bytesEnviados, inicio, ahora } = this.subida;
      const mb = (b) => (b / (1024 * 1024)).toFixed(1);
      const porcentaje = bytesTotal ? Math.min(100, Math.round((bytesEnviados * 100) / bytesTotal)) : 0;

      let restante = "";
      const segundos = (ahora - inicio) / 1000;
      if (bytesEnviados > 0 && segundos >= 5) {
        const faltan = (bytesTotal - bytesEnviados) / (bytesEnviados / segundos);
        restante = faltan >= 60 ? "~" + Math.ceil(faltan / 60) + " min" : "~" + Math.ceil(faltan) + " s";
      }

      return { porcentaje, mbEnviados: mb(bytesEnviados), mbTotal: mb(bytesTotal), restante };
    },
  },
  watch: {
    sendingType() {
      this.paginaArchivos = 1;
    },
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    Recomendaciones: () => import("@/containers/layout/Recomendaciones.vue"),
    BannerRight: () => import("@/containers/layout/banner-right.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  methods: {
    limpiarInputReset() {
      this.$refs.archivo.reset();
    },

    prevalidar(seleccion) {
      const files = [].concat(seleccion || []);
      this.batchId = null;
      this.loteEnCola = null;
      this.sendingType = null;
      this.paginaArchivos = 1;

      const items = files.map((f) => {
        const requerido = this.esRequerido(this.nombreSinExtension(f.name));
        return {
          name: f.name,
          file: requerido ? f : null,
          progress: 0,
          errors: requerido
            ? []
            : [
              "El archivo adjunto no es requerido como soporte, ya que no se encuentra registrado en nuestra base de datos.",
            ],
          success: false,
          error: !requerido,
        };
      });

      items.sort((a, b) => b.error - a.error);

      this.sending = items;
    },

    async enviarArchivos() {
      const porEnviar = this.sending.filter((s) => !s.error && !s.success && s.file);
      if (!porEnviar.length) return;

      this.envio_anexos = true;
      this.loteEnCola = null;

      this.batchId = this.generarBatchId();
      const batchTotal = porEnviar.length;

      const ahora = Date.now();
      this.subida = {
        archivos: batchTotal,
        terminados: 0,
        bytesTotal: porEnviar.reduce((total, s) => total + (s.file.size || 0), 0),
        bytesEnviados: 0,
        inicio: ahora,
        ahora,
      };

      const bloques = this.dividirEnBloques(porEnviar);
      const trabajador = async () => {
        while (bloques.length) {
          await this.enviarBloque(bloques.shift(), batchTotal);
        }
      };
      await Promise.all(
        Array.from(
          { length: Math.min(this.bloquesSimultaneos, bloques.length) },
          trabajador
        )
      );

      if (porEnviar.some((s) => s.success)) {
        await this.procesarLote();
      }

      this.envio_anexos = false;
      this.getPendientes(1);
    },

    async enviarBloque(bloque, batchTotal) {
      const datos = new FormData();
      bloque.forEach((item) => datos.append("cargues[]", item.file));
      datos.append("batch_id", this.batchId);
      datos.append("batch_total", batchTotal);

      
      const bytesBloque = bloque.reduce((total, item) => total + (item.file.size || 0), 0);
      let contados = 0;
      const sumarBytes = (bytes) => {
        this.subida.bytesEnviados += bytes - contados;
        this.subida.ahora = Date.now();
        contados = bytes;
      };

      try {
        await this.$store.state.api.post(
          "/cargue_archivos_portal/pagos/portal/batch",
          datos,
          {
            onUploadProgress: (progressEvent) => {
              if (!progressEvent.total) return;
              sumarBytes(Math.round((bytesBloque * progressEvent.loaded) / progressEvent.total));
            },
          }
        );

        // Cualquier respuesta 2xx significa que todo el bloque fue recibido.
        bloque.forEach((item) => {
          item.success = true;
          item.progress = 100;
        });
      } catch (err) {
        console.log(err);
        const mensajes = this.mensajesDeError(err);
        bloque.forEach((item) => {
          item.error = true;
          item.errors.push(...mensajes);
        });
      } finally {
        sumarBytes(bytesBloque);
        this.subida.terminados += bloque.length;
      }
    },

    async procesarLote() {
      this.procesando = true;
      try {
        await this.$store.state.api.post(
          "/cargue_archivos_portal/pagos/portal/procesar",
          { batch: this.batchId }
        );
        this.loteEnCola = this.batchId;
        this.$toasted.show("El lote quedó en cola. Ya puedes salir de esta pantalla", {
          theme: "toasted-primary",
          position: "top-right",
          duration: 5000,
        });
      } catch (err) {
        console.log(err);
        this.$toasted.show(
          "Los archivos se cargaron, pero no se pudo iniciar el procesamiento del lote: " +
          this.mensajesDeError(err).join(" "),
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 8000,
          }
        );
      } finally {
        this.procesando = false;
      }
    },

    cambiarTab(nuevoTab) {
      if (nuevoTab === 1) this.getBatches();
    },
    async getBatches() {
      this.cargandoBatches = true;
      try {
        const request = await this.$store.state.api.get(
          "/cargue_archivos_portal/pagos/portal/batches"
        );
        this.batches = request.data.datos || [];
      } catch (err) {
        this.$toasted.show(
          "Ocurrió un error intentando consultar los cargues en lote",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      } finally {
        this.cargandoBatches = false;
      }
    },
    async descargarLog(item) {
      this.descargandoLog = item.batch;
      try {
        const { data } = await this.$store.state.api.get(
          "/cargue_archivos_portal/pagos/portal/log",
          { params: { batch: item.batch }, responseType: "arraybuffer" }
        );
        saveAs(
          new Blob(["﻿", data], { type: "text/csv;charset=utf-8;" }),
          "log_anexos_" + item.batch + ".csv"
        );
      } catch (err) {
        this.$toasted.show("No fue posible descargar el log del lote", {
          theme: "toasted-primary",
          position: "top-right",
          duration: 5000,
        });
      } finally {
        this.descargandoLog = null;
      }
    },
    varianteEstado(estado) {
      switch (estado) {
        case "FINALIZADO":
          return "success";
        case "PROCESANDO":
          return "info";
        case "EN COLA":
        case "PREPROCESANDO":
          return "secondary";
        case "error":
          return "danger";
        default:
          return "light";
      }
    },
    // Agrupa los archivos en bloques de máximo `archivosPorBloque` archivos
    // y `bytesPorBloque` bytes, para no superar los límites del servidor.
    dividirEnBloques(items) {
      const bloques = [];
      let actual = [];
      let bytes = 0;
      for (const item of items) {
        const tamanio = item.file.size || 0;
        if (
          actual.length &&
          (actual.length >= this.archivosPorBloque ||
            bytes + tamanio > this.bytesPorBloque)
        ) {
          bloques.push(actual);
          actual = [];
          bytes = 0;
        }
        actual.push(item);
        bytes += tamanio;
      }
      if (actual.length) bloques.push(actual);
      return bloques;
    },
    nombreSinExtension(nombre) {
      return nombre.replace(/\.pdf$/i, "");
    },
    esRequerido(file_name) {
      return this.clavesPendientes.has(file_name);
    },
    // Advierte antes de cerrar o recargar la pestaña solo mientras se suben archivos
    avisoSalida(e) {
      if (!this.envio_anexos) return;
      e.preventDefault();
      e.returnValue = "";
    },
    generarBatchId() {
      const c = window.crypto;
      // randomUUID solo existe en navegadores recientes y en HTTPS/localhost
      if (c && typeof c.randomUUID === "function") return c.randomUUID();
      if (c && typeof c.getRandomValues === "function") {
        const b = c.getRandomValues(new Uint8Array(16));
        b[6] = (b[6] & 0x0f) | 0x40; // versión 4
        b[8] = (b[8] & 0x3f) | 0x80; // variante RFC 4122
        const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
        return (
          h.slice(0, 8) + "-" + h.slice(8, 12) + "-" + h.slice(12, 16) + "-" +
          h.slice(16, 20) + "-" + h.slice(20)
        );
      }
      return Date.now().toString(16) + "-" + Math.random().toString(16).slice(2);
    },
    // Extrae los mensajes de error que devuelva la API (errors de validación o message)
    mensajesDeError(err) {
      if (!err.response) {
        return ["No se pudo enviar el archivo por un problema de conexión."];
      }
      const data = err.response.data || {};
      const mensajes = [];
      if (data.errors && typeof data.errors === "object") {
        Object.values(data.errors).forEach((m) => mensajes.push(...[].concat(m)));
      }
      if (!mensajes.length && data.message) mensajes.push(data.message);
      if (!mensajes.length) {
        mensajes.push(
          "El servidor rechazó el archivo (código " + err.response.status + ")."
        );
      }
      return mensajes;
    },
    async clickEvent(element, slug) {
      console.log(element, slug);
      if (slug == "paginacion") {
        this.getPendientes(element.page);
      }
    },
    async getPendientes(page = 1, paginar = "false") {
      this.end_consulta_anexos = false;
      try {
        let request = await this.$store.state.api.get("/informes/estado_pago", {
          params: {
            paginar,
            row: this.perPage,
            page,
          },
        });
        this.dataPendientes = request.data.datos;
        this.dataLength = request.data.paginacion.total;
        this.end_consulta_anexos = true;
      } catch (err) {
        this.end_consulta_anexos = true;
        this.$toasted.show(
          "Ocurrió un error intentando consultar los registros pendientes",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      }
    },
    escapeCsvValue(valor) {
      if (valor === null || valor === undefined) return "";
      const texto = String(valor);
      if (texto.includes(";") || texto.includes('"') || texto.includes("\n")) {
        return '"' + texto.replace(/"/g, '""') + '"';
      }
      return texto;
    },
    nombreArchivoDescarga() {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return (
        "pendientes_anexos_reclamacion_" +
        d.getFullYear() +
        pad(d.getMonth() + 1) +
        pad(d.getDate()) +
        "_" +
        pad(d.getHours()) +
        pad(d.getMinutes()) +
        ".csv"
      );
    },
    async descargarPendientes() {
      this.descargandoPendientes = true;
      try {
        let request = await this.$store.state.api.get("/informes/estado_pago", {
          params: {
            paginar: "false",
            row: 100000,
            page: 1,
          },
        });
        const registros = request.data.datos || [];

        if (!registros.length) {
          this.$toasted.show("No hay registros pendientes para descargar", {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          });
          return;
        }

        const encabezados = ["Cédula", "Pagaré", "Nombres", "Estado"];
        const filas = registros.map((registro) =>
          [
            registro.cedula,
            registro.pagare,
            registro.nombre_cliente,
            registro.estado,
          ]
            .map((valor) => this.escapeCsvValue(valor))
            .join(";")
        );
        const contenidoCsv = [encabezados.join(";"), ...filas].join("\r\n");

        const blob = new Blob(["\uFEFF" + contenidoCsv], {
          type: "text/csv;charset=utf-8;",
        });
        saveAs(blob, this.nombreArchivoDescarga());
      } catch (err) {
        this.$toasted.show(
          "Ocurrió un error intentando generar la descarga de pendientes",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      } finally {
        this.descargandoPendientes = false;
      }
    },
  },
  mounted() {
    console.log("AnexosReclamacion");
    window.addEventListener("beforeunload", this.avisoSalida);
    this.getPendientes(1);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.avisoSalida);
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.envio_anexos &&
      !window.confirm("Se están subiendo archivos. Si sales ahora, la subida se cancela. ¿Deseas salir?")
    ) {
      return next(false);
    }
    next();
  },
};
</script>
<style>
.card-body {
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.4s ease;
}

.card-body:hover {
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.custom-list-group {
  display: flex;
  width: 600px;
}

.custom-list-item {
  flex: 1;
}
</style>